import { UiKit } from '@datavant/idsb-shared/uikit';
import React from 'react';

export const DebugPopoverFooter = (props: {
    onCancelClicked: () => void;
    onApplyClicked: () => void;
}): JSX.Element => (
    <UiKit.Chakra.PopoverFooter
        border="1"
        display="flex"
        alignItems="center"
        bgColor={'white'}
        justifyContent="flex-end"
        p={UiKit.consistency.buffer}
    >
        <UiKit.Chakra.ButtonGroup size="sm">
            <UiKit.Button.Cancel text={'Cancel'} onClick={props.onCancelClicked} />
            <UiKit.Button.Primary text={'Apply'} onClick={props.onApplyClicked} />
        </UiKit.Chakra.ButtonGroup>
    </UiKit.Chakra.PopoverFooter>
);
